import { render, staticRenderFns } from "./wechatapp.vue?vue&type=template&id=6459c382&scoped=true"
import script from "./wechatapp.vue?vue&type=script&lang=js"
export * from "./wechatapp.vue?vue&type=script&lang=js"
import style0 from "./wechatapp.vue?vue&type=style&index=0&id=6459c382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6459c382",
  null
  
)

export default component.exports